// Module
var code = `<label class="field"> <input/> </label> `;
// Exports
export default code;